import { createFileRoute } from "@tanstack/react-router";

import { ExerciseCatalog } from "@/features/exercises/modules/exercise-catalog/exercise-catalog";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/library/exercises")({
  loader: () => ({ crumb: m.library_tab_exercises() }),
  component: RouteComponent,
});

function RouteComponent() {
  return <ExerciseCatalog />;
}
